export default "__VITE_ASSET__BuxJBmIC__"